import axios from "axios";
import { JSON_CONTENT_FORM_CONFIG, MULTIPART_FORM_CONFIG } from "../Config";

export const registerStore = (formData) => async (dispatch) => {
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/stores/register/`,
    formData,
    MULTIPART_FORM_CONFIG
  );
  return res.data.success;
};

export const listStores = async (
  page = 1,
  per_page = 9,
  suborganization_ids = [],
  q = ""
) => {
  let params = `?page=${page}&per_page=${per_page}`;
  if (suborganization_ids.length > 0) {
    params += `&suborganization_ids=${JSON.stringify(suborganization_ids)}`;
  }
  if (q.toString().length > 0) {
    params += `&q=${q}`;
  }
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/stores/list/${params}`,
    JSON_CONTENT_FORM_CONFIG
  );
  return res.data;
};

export const listStoresUnderReview = async (
  page = 1,
  per_page = 9,
  suborganization_ids = [],
  q = ""
) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("per_page", per_page);

  if (suborganization_ids.length > 0) {
    params.append("suborganization_ids", JSON.stringify(suborganization_ids));
  }

  if (q.toString().length > 0) {
    params.append("q", q);
  }

  const res = await axios.get(
    `${
      process.env.REACT_APP_API_BASE_URL
    }/stores/list-stores-under-review/?${params.toString()}`,
    JSON_CONTENT_FORM_CONFIG
  );

  return res.data;
};

export const reviewAcceptStore = (id) => async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/stores/review-and-create-store/`,
      { id },
      MULTIPART_FORM_CONFIG
    );
    return res.data.success;
  } catch {
    return false;
  }
};

export const storeDetail = async (slug) => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/stores/detail/?slug=${slug}`,
    JSON_CONTENT_FORM_CONFIG
  );
  return res.data;
};

export const visitStore = (formData) => async (dispatch) => {
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/stores/register-visit/`,
    formData,
    MULTIPART_FORM_CONFIG
  );
  return res.data.success;
};

export const createStoreOrder = (formData) => async (dispatch) => {
  console.log(JSON.stringify(formData));
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/stores/create-store-order/`,
    JSON.stringify(formData),
    JSON_CONTENT_FORM_CONFIG
  );
  console.log(res.data);
  return res.data.success;
};

export const listStoreOrders =
  (store = "", page = 1, per_page = 10, suborganization_ids = []) =>
  async (dispatch) => {
    let params = `page=${page}&per_page=${per_page}`;
    if (suborganization_ids.length > 0)
      params += `&suborganization_ids=${JSON.stringify(suborganization_ids)}`;
    if (store.length > 0) params += `&store=${store}`;
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/stores/orders/?${params}`,
      JSON_CONTENT_FORM_CONFIG
    );
    return res.data;
  };

export const listStoreVisits =
  (store = "", page = 1, per_page = 10) =>
  async (dispatch) => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/stores/visits/?store=${store}&page=${page}&per_page=${per_page}`,
      JSON_CONTENT_FORM_CONFIG
    );
    return res.data;
  };
